import { useEffect, useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { requireAuth } from '../lib/authClient'

export default function ProtectedRoute() {
  const [status, setStatus] = useState<'loading' | 'ok' | 'no'>('loading')

  useEffect(() => {
    ;(async () => {
      const me = await requireAuth()
      setStatus(me ? 'ok' : 'no')
    })()
  }, [])

  if (status === 'loading') return <div className="p-6">Loading…</div>
  if (status === 'no') return <Navigate to="/login" replace />
  return <Outlet />
}
